import { getRequestFunction } from './requestFunction';

export const REQUEST_QUEUE_ENDED_EVENT = 'requestQueueEnded';

/* eslint-disable camelcase */
window.pushQueueRequest = function pushQueueRequest(panelId, request) {
  const panel = window.getRealPannel(panelId);
  if (!panel) {
    return;
  }

  if (!Array.isArray(panel.request_queue)) {
    panel.request_queue = [];
    if (!Array.isArray(window.request_queues)) window.request_queues = [];
    let found = false;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < window.request_queues.length; i++) {
      if (window.request_queues[i] === panel.id) {
        found = true;
        break;
      }
    }
    if (!found) window.request_queues.push(panel.id);
  }

  const requestFn = getRequestFunction(request);
  if (!requestFn) {
    return;
  }

  panel.request_queue.push(requestFn);
};

window.popQueueRequestAndProcess = function popQueueRequestAndProcess(panelId) {
  const panel = window.getRealPannel(panelId);

  const dispatchRequestQueueEndEvent = () => {
    const event = new CustomEvent(REQUEST_QUEUE_ENDED_EVENT);
    window.dispatchEvent(event);
  };

  if (!panel) {
    dispatchRequestQueueEndEvent();
    return;
  }
  if (!Array.isArray(panel.request_queue)) {
    panel.request_queue = [];
  }
  if (panel.request_queue.length < 1) {
    dispatchRequestQueueEndEvent();
    return;
  }

  let group = false;
  while (panel.request_queue.length > 0) {
    const request = panel.request_queue.pop();

    if (typeof request === 'string') {
      if (request === 'group_end') break;
      if (request === 'group_start') {
        group = true;
        continue;
      }
    }

    request?.();

    if (window.lsCloud.Modules.hasModule('ajax_request_queue') && !group) break;
  }
};

window.clearAllRequestQueues = function clearAllRequestQueues() {
  if (!window || window.closing) return;
  if (!Array.isArray(window.request_queues)) return;
  if (!window.request_queues.length) return;
  if (window.request_queues.length < 1) return;

  for (let i = 0; i < window.request_queues.length; i++) {
    const pannel = window.getRealPannel(window.request_queues[i]);
    if (pannel && pannel.request_queue) pannel.request_queue = [];
  }
  window.request_queues = [];
};

window.clearRequestQueue = function clearRequestQueue(pannel_id) {
  const pannel = window.getRealPannel(pannel_id);
  if (!pannel) return window.clearAllRequestQueues();
  if (pannel.request_queue) pannel.request_queue = [];
};

window.finishAjaxRequest = function finishAjaxRequest(pannel_id, result, callback) {
  if (result.requests) {
    if (result.requests.length > 0) {
      for (let i = 0; i < result.requests.length; i++) {
        window.pushQueueRequest(pannel_id, result.requests[i]);
      }
    }
  }

  window.popQueueRequestAndProcess(pannel_id);
  if (typeof callback !== 'undefined') {
    callback();
  }
};
